import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { unsubscribePushSubscription } from "../pushNotifications";

const Logout = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const performLogout = async () => {
            try {
                await unsubscribePushSubscription();
            } catch (error) {
                console.error("Push unsubscribe failed:", error);
            } finally {
                localStorage.removeItem("access");
                localStorage.removeItem("refresh");
                navigate("/login");
            }
        };

        performLogout();
    }, [navigate]);

    return <p>Logging out...</p>;
};

export default Logout;
